import { z } from 'zod';
import { createNumericKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { uniquePlayerColorsArraySchema } from '../SharedZodSchemas.ts';
import { validateState } from '../ValidateState.ts';
const islandStateSchema = z.object({
    tileIndexes: z.array(z.number().int().nonnegative()).readonly(),
    playersThatSettledIsland: uniquePlayerColorsArraySchema
}).strict();
const islandStatesSchema = createNumericKeyRecordSchema(islandStateSchema);
const islandStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(islandStateSchema);
const islandStatesPartialSchema = createNumericKeyRecordSchema(islandStatePartialSchema, {
    requireAtLeastOneEntry: true
});
export const mechanicIslandExplorationStateSchema = z.object({
    doesDesertCountAsForeignLand: z.boolean().readonly(),
    islandStates: islandStatesSchema.readonly()
}).strict();
export function validateMechanicIslandExplorationState(data) {
    return validateState(mechanicIslandExplorationStateSchema, data);
}
const mechanicIslandExplorationStatePartialShapeSchema = z.object({
    doesDesertCountAsForeignLand: z.boolean().readonly(),
    islandStates: islandStatesPartialSchema.readonly()
}).strict();
export const mechanicIslandExplorationStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicIslandExplorationStatePartialShapeSchema);
